import { combineReducers } from "redux";

import ssm from "../features/admin/management/ssm/Slice";
import sm from "../features/admin/management/sm/Slice";
import master from "../features/admin/management/master/Slice";
import client from "../features/admin/management/client/Slice";

const management = combineReducers({
  ssm,
  sm,
  master,
  client,
});

export default management;
